// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hsSVXNTR3S7QDh7Dww7k {
  height: calc(100vh - 4rem);
  padding: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 0;
}

.oZjeZYYaT08mpbjwdUyl {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
}

.FUzJtD9eEcyzB2rQm_D7 {
  margin-top: 0;
  margin-bottom: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/views/ServerError/ServerError.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".container {\n  height: calc(100vh - 4rem);\n  padding: 2rem;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 0;\n}\n\n.title {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n}\n\n.description {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hsSVXNTR3S7QDh7Dww7k`,
	"title": `oZjeZYYaT08mpbjwdUyl`,
	"description": `FUzJtD9eEcyzB2rQm_D7`
};
export default ___CSS_LOADER_EXPORT___;
